import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { LayoutSelector as OHIFLayoutSelector, ToolbarButton } from '@ohif/ui';

import { ServicesManager } from '@ohif/core';

function LayoutSelector({
  rows,
  columns,
  className,
  servicesManager,
  ...rest
}) {
  const [isOpenTab, setIsOpenTab] = useState(false);

  const {
    hangingProtocolService,
    toolbarService,
  } = (servicesManager as ServicesManager).services;

  useEffect(() => {
    const { unsubscribe } = hangingProtocolService.subscribe(
      hangingProtocolService.EVENTS.PROTOCOL_CHANGED,
      evt => {
        const { protocol } = evt;
      }
    );

    return () => {
      unsubscribe();
    };
  }, [hangingProtocolService]);

  window.memoElIconeBtnLayout = "";

  const ocultarMenuGrid = (el) => {
    const elIconeBtnLayout = document.getElementById('btnLayout');
    const isOpenMenu = document.getElementById('btnLayout').lastChild.lastChild.classList.contains("hidden") === false;
    const isViewportElement = el.target.getElementsByClassName('viewport-element').length > 0;
    if (elIconeBtnLayout && isOpenMenu || isViewportElement) {
      if (window.memoElIconeBtnLayout !== el.target.tagName)
        elIconeBtnLayout.getElementsByTagName('button')[0].click();
      window.memoElIconeBtnLayout = el.target.tagName;
    }
  }

  window.addEventListener('click', (e) => {
    const elId = e.target.id;
    const tagName = e.target.tagName;
    if (tagName === 'CANVAS') {
      ocultarMenuGrid(e);
      return;
    }
    if (tagName === 'DIV') {
      ocultarMenuGrid(e);
      return;
    }
    if (tagName === 'BUTTON' && elId !== 'icon-Layout') {
      ocultarMenuGrid(e);
      return;
    }
  })

  const onInteractionHandler = () => setIsOpenTab(!isOpenTab);
  const DropdownContent = isOpenTab ? OHIFLayoutSelector : null;

  const onSelectionHandler = props => {
    toolbarService.recordInteraction({
      interactionType: 'action',
      commands: [
        {
          commandName: 'setViewportGridLayout',
          commandOptions: { ...props },
          context: 'DEFAULT',
        },
      ],
    });
  };

  return (
    <ToolbarButton
      id="Layout"
      label="Grid Layout"
      icon="tool-layout"
      onInteraction={onInteractionHandler}
      className={className}
      rounded={rest.rounded}
      dropdownContent={
        DropdownContent !== null && (
          <DropdownContent
            rows={rows}
            columns={columns}
            onSelection={onSelectionHandler}
          />
        )
      }
      isActive={isOpenTab}
      type="toggle"
    />
  );
}

LayoutSelector.propTypes = {
  rows: PropTypes.number,
  columns: PropTypes.number,
  onLayoutChange: PropTypes.func,
  servicesManager: PropTypes.instanceOf(ServicesManager),
};

LayoutSelector.defaultProps = {
  rows: 3,
  columns: 3,
  onLayoutChange: () => { },
};

export default LayoutSelector;
